import React from 'react';
class Disney extends React.Component {
    render() {
        return (
            <div style={{
                display: "flex",
                flexFlow: "column",
                borderBottom: "1px solid #ccc"
            }}>
                <h4>Overview</h4>
                <p>
                    Working with the Central Technology team as an Analytics Engineer I was responsible for
                    collecting
                    data from many Disney owned domains including Disney.com and StarWars.com. I modularized a
                    complex
                    JavaScript library on the frontend and built high volume services on the backend in Java and
                    Go.
                    I helped analyse raw data and built web GUIs to display metrics. I evaluated cloud pricing
                    and migrated in-house code to Google App Engine. I provided coding support to the native
                    mobile
                    libraries written in Objective-C, Java, and C# (Unity).
                </p>
                <h4>Notable Achievements</h4>
                <ul>
                    <li>
                        Took ownership, modularized, debugged, and added features to a JavaScript library
                        currently used on Disney.com, StarWars.com, ESPN.com LucasFilm.com, DisneyBaby.com, and
                        Babble.com
                    </li>
                    <ul>
                        <li>Node.js</li>
                        <li>RequireJS</li>
                    </ul>
                    <li>
                        Built, integrated and deployed a solution to copy visitor and session data across Disney
                        owned
                        domains
                    </li>
                    <ul>
                        <li>Go</li>
                        <li>Google App Engine</li>
                        <li>CORS</li>
                    </ul>
                    <li>Spoke during monthly knowledge sharing presentations in front other teams</li>
                </ul>
            </div>
        )
    }
}

export default Disney;